import React from 'react'
import { DIALOG_MENU_PROPS } from '../ravenV5Theme'
import { Button } from '@atd/rui-base.mui.button'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { MenuItem } from '@atd/rui-base.mui.menu-item'
import { Select } from '@atd/rui-base.mui.select'
import ValidatedTextField from '../commonComponents/validatedTextField'
import ResponsiveDialog from '../commonComponents/responsiveDialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import DialogHeader from '../commonComponents/dialogHeader'

import PropTypes from 'prop-types'

import { ingredientTypes } from './productPrototypes'
import { ACTUAL_MASS_CONTENT_DDI, ACTUAL_VOLUME_CONTENT_DDI } from '../lib/ddiConstants'
import {getMenuItemsForProductDDI} from '../commonComponents/unitMenuItems'
import {getUnitEquivalentForDDI} from '../lib/ddiUnits'
import { emptyForNull } from '../lib/formData'

const typeMenuItems = []
for (let i = 0; i < ingredientTypes.length; i++) {
    typeMenuItems.push(<MenuItem value={ingredientTypes[i].name} key={ingredientTypes[i].name}>{ingredientTypes[i].name}</MenuItem>)
}
class IngredientEdit extends React.Component {
    static propTypes = {
        data: PropTypes.object,
    }

    static defaultProps = {
        data: {
            id: -1,
            name: '',
            typeId: 'Herbicide',
            ddiId: ACTUAL_VOLUME_CONTENT_DDI,
            manufacturer: '',
            defaultDisplayUnit: '',
            registration: '',
            note: '',
            composition: '',
            deprecated: false,
        },
    }

    state = {
        open: true,
        ...emptyForNull(this.props.data),
        errorMessage: '',
    }

    handleTextChange = (event) => {
        const formData = {...this.state}
        formData[event.target.name] = event.target.value
        this.setState(formData)
    }

    handleDdi = (event, index, value) => {
        const displayUnit = getUnitEquivalentForDDI(this.state.defaultDisplayUnit, value)
        this.setState({ ddiId: value, defaultDisplayUnit: displayUnit })
    }
    handleTypeId = (event, index, value) => {
        this.setState({typeId: value})
    }
    handleDefaultUnit = (event, index, value) => {
        this.setState({defaultDisplayUnit: value})
    }
    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    handleSave = () => {
        if (!this.state.name || this.state.name.length > 32 ||
            this.state.manufacturer.length > 32 ||
            this.state.registration.length > 32 ||
            this.state.note.length > 330 ||
            this.state.composition.length > 330
        ) {
            this.setState({errorMessage: 'Invalid Data'})
        }
        else {
            this.requestClose(() => this.props.onSave({ ...this.state }))
        }
    }
    handleCancel = () => {
        this.requestClose(this.props.onCancel)
    }

    render() {
        const units = getMenuItemsForProductDDI(this.state.ddiId)
        const editActions = [
            <div key="error" style={{display: 'inline-block', color: 'red'}}>{this.state.errorMessage}</div>,
            <Button key="cancel" variant="text"
                color="primary"
                onClick={this.handleCancel}
                name="cancelButton">Cancel</Button>,
            <Button key="save" variant="contained"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_SaveWhite.svg`}/>}
                color="primary"
                onClick={this.handleSave}
                name="saveButton">{'Save'}</Button>,
        ]

        return (
            <ResponsiveDialog
                open={this.state.open}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.handleSave() }}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                PaperProps={{className: 'wodialog'}}
                fullWidth
                name="ingredientDialog"
            >
                <DialogHeader onClose={this.handleCancel}>Ingredient Information</DialogHeader>
                <DialogContent>
                    <ValidatedTextField
                        label="Ingredient Name"
                        fullWidth={true}
                        onChange={this.handleTextChange}
                        value={this.state.name || ''}
                        name="name"
                        disabled={this.props.disabled}
                        errorText={(!this.state.name && 'Required Field') || (this.state.name.length > 32 && 'Max Length 32')}
                    />
                    <ValidatedTextField
                        label="Manufacturer"
                        fullWidth={true}
                        onChange={this.handleTextChange}
                        value={this.state.manufacturer || ''}
                        name="manufacturer"
                        disabled={this.props.disabled}
                        errorText={this.state.manufacturer && (this.state.manufacturer.length > 32 && 'Max Length 32')}
                    />
                    <div style={{display: 'flex', gap: '16px', marginTop: '16px'}}>
                        <FormControl variant="standard" sx={{width: '185px'}} disabled={this.props.disabled}>
                            <Select
                                MenuProps={DIALOG_MENU_PROPS}
                                value={this.state.typeId}
                                onChange={(event) => this.handleTypeId(event, null, event.target.value)}
                                name="ingredientType"
                            >
                                {typeMenuItems}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" sx={{width: '185px'}} disabled={this.props.disabled}>
                            <Select
                                MenuProps={DIALOG_MENU_PROPS}
                                value={this.state.ddiId}
                                onChange={(event) => this.handleDdi(event, null, event.target.value)}
                                name="granularLiquidDropdown"
                            >
                                <MenuItem value={ACTUAL_MASS_CONTENT_DDI}>Granular</MenuItem>
                                <MenuItem value={ACTUAL_VOLUME_CONTENT_DDI}>Liquid</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginTop: '16px'}}>
                        <span>Unit:</span>
                        <FormControl variant="standard" sx={{width: '185px'}} disabled={this.props.disabled}>
                            <Select
                                MenuProps={DIALOG_MENU_PROPS}
                                value={this.state.defaultDisplayUnit}
                                onChange={(event) => this.handleDefaultUnit(event, null, event.target.value)}
                                name="defaultUnitDropDown"
                            >
                                {units}
                            </Select>
                        </FormControl>
                    </div>
                    <ValidatedTextField
                        label="Registration"
                        fullWidth={true}
                        onChange={this.handleTextChange}
                        value={this.state.registration || ''}
                        name="registration"
                        disabled={this.props.disabled}
                        errorText={this.state.registration && (this.state.registration.length > 32 && 'Max Length 32')}
                    />
                    <ValidatedTextField
                        label="Composition"
                        fullWidth={true}
                        onChange={this.handleTextChange}
                        value={this.state.composition || ''}
                        name="composition"
                        disabled={this.props.disabled}
                        multiline={true}
                        errorText={this.state.composition && (this.state.composition.length > 330 && 'Max Length 330')}
                    />
                    <ValidatedTextField
                        label="Notes"
                        fullWidth={true}
                        onChange={this.handleTextChange}
                        value={this.state.note || ''}
                        name="note"
                        disabled={this.props.disabled}
                        multiline={true}
                        errorText={this.state.note && (this.state.note.length > 330 && 'Max Length 330')}
                    />
                </DialogContent>
                <DialogActions>{editActions}</DialogActions>
            </ResponsiveDialog>
        )
    }
}
export default IngredientEdit
